export enum RegisterEvent {
    Generic = 'Register.Generic',
    SignUp = 'Register.SignUp',
}
